
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookie-notice",
      function () {
        return require("private-next-pages/cookie-notice.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cookie-notice"])
      });
    }
  